/**
 * User: Rob Richard
 * Date: 12/19/13
 * Time: 12:12 PM
 */

"use strict";

var _ = require('underscore');
var endpoints = require('dibs-endpoints');

var SoaCollection = require('bunsen/collections/SoaCollection');
var Roles = module.exports = SoaCollection.extend();

var Role = require('bunsen/models/identity/Role');

_.extend(Roles.prototype, {
    model: Role,
    url: endpoints.roles(),
    comparator: 'name',
    parse: function (data) {
        var roles, mapping;
        if (data.roleList) {
            roles = data.roleList;
            mapping = data.rolePermissionMappings;
        } else if (data.result && data.result.roles && data.result.roles.roleList) {
            roles = data.result.roles.roleList;
            mapping = data.result.roles.rolePermissionMappings;
        } else {
            return data;
        }

        //parse the roles - permissions mapping
        if (roles && mapping) {
            _.each(roles, function (role) {
                role.permissions = [];
                _.each(_.where(mapping, {name: role.id}), function (permission) {
                    role.permissions.push({
                        id: permission.value
                    });
                });
            });
        }

        return roles;
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/identity/Roles.js
// module id = 2040
// module chunks = 64